<template>
  <div>
    <Line :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'vue-chartjs';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

export default {
  extends: Line,
  components: {
    Line,
  },
  props: {
    titulo: {
      type: Array,
      required: true,
    },
    media: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chartData: {
        labels: this.titulo,
        datasets: [
          {
            label: 'Média',
            data: this.media,
            backgroundColor: '#008000',
            fill: false,
            borderColor: '#008000',
            tension: 0.1,
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            title: {
              display: true,
              text: 'Titulo da Avaliação',
              font: {
                weight: 'bold',
              },
            },
          },
          y: {
            title: {
              display: true,
              text: 'Média',
              font: {
                weight: 'bold',
              },
            },
          },
        },
      },
    };
  },
};
</script>
